// ==========================================================================
// Selectric module
// ==========================================================================
import AbstractModule from './AbstractModule';
import {$document} from '../utils/environment';
import Scrollbar from 'smooth-scrollbar';

export default class extends AbstractModule {
    constructor(options) {
        super(options);
        this.$el = options.$el;

        this.init();
        this.hasSmoothScrollbar = false;
    }

    init() {
        this.$el.find('.js-selectric').selectric({
            arrowButtonMarkup: '<svg class="selectric-icon" role="img"><use xlink:href="assets/images/sprite.svg#icon-arrow-select"></use></svg>',
            onInit: () => this.initScrollbar(),
            onRefresh: () => this.updateScrollbar()
        });
    }

    initScrollbar() {
        if (!window.App.iOS && window.innerWidth > 1024) {
            this.scrollbar = Scrollbar.init(this.$el.find('.selectric-scroll')[0], { alwaysShowTracks: true });
            this.hasSmoothScrollbar = true;
        }
    }

    updateScrollbar() {
        if (this.hasSmoothScrollbar) {
            this.scrollbar.update();
        }
    }

    destroy() {
        this.$el.off('.Selectric');
        this.scrollbar?.destroy();

        this.hasSmoothScrollbar = false;
    }
}
